/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { XMarkIcon } from "@heroicons/react/24/outline";
import {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import styled from "styled-components";

export const PopupContext = createContext();

const PopupWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 10;
  background-color: rgba(51, 51, 51, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;

  & .popup-inner {
    background-color: #fff;
    border-radius: 20px;
    box-shadow: 9px 9px 16px rgba(0, 0, 0, 0.1);
    min-width: 300px;
    position: relative;
    padding: 40px 45px;
    max-width: 1024px;

    & .close-icon {
      color: #48484b;
      width: 30px;
      height: 30px;
      padding: 3px;
      position: absolute;
      top: 16px;
      right: 16px;
    }
  }
`;

export const PopupProvider = ({ children }) => {
  const [showPopup, setShowPopup] = useState();
  const popupRef = useRef(null);

  useEffect(() => {}, [showPopup]);

  const openPopup = (componentToRender, options = {}) =>
    setShowPopup({ Component: componentToRender, options });

  const { Component, options } = showPopup || {};
  const { onClose } = options || {};

  const closePopup = (e) => {
    if (e.target === popupRef.current) {
      setShowPopup(false);
      if (typeof onClose === "function") onClose();
    }
  };

  const cancel = () => {
    setShowPopup(false);
    if (typeof onClose === "function") onClose();
  };

  const value = {
    openPopup,
    closePopup: () => setShowPopup(false),
  };

  return (
    <>
      {useMemo(
        () => (
          <PopupContext.Provider value={value}>
            {children}
          </PopupContext.Provider>
        ),
        []
      )}
      {!!showPopup && (
        <PopupWrapper ref={popupRef} onClick={closePopup}>
          <div className="popup-inner">
            <XMarkIcon className="close-icon" onClick={cancel} />
            {!!Component && Component}
          </div>
        </PopupWrapper>
      )}
    </>
  );
};

const usePopupContext = () => useContext(PopupContext);

export default usePopupContext;
